/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon20Regular = forwardRef('BuildingGovIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.37 3.726a2.648 2.648 0 0 1 3.26 0l5.908 4.615a.75.75 0 1 0 .924-1.182l-5.908-4.615a4.148 4.148 0 0 0-5.108 0L1.538 7.159a.75.75 0 0 0 .924 1.182L8.37 3.726Z" }),
        React.createElement("path", { d: "M6 8.75a.75.75 0 1 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5Z" }),
        React.createElement("path", { d: "M2.344 16.25a.75.75 0 0 0 0 1.5h15.312a.75.75 0 0 0 0-1.5H2.344Z" }),
        React.createElement("path", { d: "M8.4 8a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 8.4 8Z" }),
        React.createElement("path", { d: "M12.35 8.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5Z" }),
        React.createElement("path", { d: "M14.749 8a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75Z" })));
});
